export const pickCountryStepStyles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		gap: 2,
		p: 2,
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%'
	},

	title: {
		mb: 1.5
	},

	field: {
		width: '100%'
	}
};
